import { useEffect, useRef } from 'react';

import { countryModel } from 'entities/country';

import { Disease, EUserRole } from 'shared/api';

import { getDiseasePetsByIdAsync } from '../../model/disease-pets';
import { DiseaseDialog } from '../disease-dialog';

type Props = {
  diseaseId: string;
  userRole?: EUserRole;
  isLoading: boolean;
  preselectedCountryCode?: string;
  onClose: () => void;
  onVerified?: (disease: Disease) => void;
  onSubmit: (disease: Disease) => void;
  onDataLoaded?: () => void;
};

export const EditDiseaseDialogPets = ({
  diseaseId,
  userRole,
  isLoading,
  preselectedCountryCode = '',
  onClose,
  onVerified,
  onSubmit,
  onDataLoaded,
}: Props) => {
  const { data: diseaseData, isLoading: isDiseaseLoading } = getDiseasePetsByIdAsync(diseaseId);
  const { data: countriesData, isLoading: isCountriesLoading } = countryModel.useAllCountries();

  const isDataReady = !isDiseaseLoading && !isCountriesLoading && !!diseaseData?.data;
  const hasCalledOnDataLoaded = useRef(false);

  // Вызываем onDataLoaded когда данные загружены
  useEffect(() => {
    if (isDataReady && !hasCalledOnDataLoaded.current) {
      hasCalledOnDataLoaded.current = true;
      onDataLoaded?.();
    }
  }, [isDataReady, onDataLoaded]);

  // Не показываем диалог пока данные грузятся
  if (!isDataReady) {
    return null;
  }

  return (
    <DiseaseDialog
      title="Edit disease"
      selectedDisease={diseaseData.data}
      isPets={true}
      diseaseList={[]} // Пустой массив - валидация уникальности имени не нужна при редактировании
      countriesList={countriesData?.data ?? []}
      userRole={userRole}
      isOpen={true}
      isLoading={isLoading}
      onClose={onClose}
      onVerified={onVerified}
      onSubmit={onSubmit}
      preselectedCountryCode={preselectedCountryCode}
    />
  );
};
